import { render } from "./PlayerContainer.vue?vue&type=template&id=2c6514d8"
import script from "./PlayerContainer.vue?vue&type=script&lang=js"
export * from "./PlayerContainer.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/Imanyat-Egypt-Systech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__